import * as actions from "./constants";

export const initialState = {
  complete: false,
  commonData: {
    data: null,
    dataFull: null,
    disabled: null,
    complete: false,
    failed: false,
    dataMap: {},
  },
  globalSettings: {
    data: null,
    complete: false,
    failed: false,
  },
};

function settingsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_COMMON:
      return {
        ...state,
        commonData: { ...state.commonData, failed: false, complete: false },
      };
    case actions.RECEIVE_COMMON:
      const map = {};
      const disabled = {};
      const dataFull = {};
      Object.keys(action.data.data).forEach((key) => {
        const mappedItems = {};
        action.data.data[key].forEach((item) => {
          mappedItems[item.id] = item;
        });
        dataFull[key] = action.data.data[key];
        if (action.data.disabled[key]) {
          disabled[key] = action.data.disabled[key];
          dataFull[key] = [...dataFull[key], ...action.data.disabled[key]];
          action.data.disabled[key].forEach((item) => {
            mappedItems[item.id] = item;
          });
        }
        map[key] = mappedItems;
      });
      return {
        ...state,
        commonData: {
          ...state.commonData,
          data: { ...action.data.data },
          disabled: disabled,
          dataFull: dataFull,
          failed: false,
          complete: true,
          dataMap: map,
        },
      };
    case actions.RECEIVE_COMMON_FAIL:
      return {
        ...state,
        commonData: {
          ...state.commonData,
          failed: true,
          complete: true,
        },
      };
    case actions.RECEIVE_SETTINGS:
      return {
        ...state,
        globalSettings: {
          data: [...action.data.data],
          failed: false,
          complete: true,
        },
      };
    case actions.HYDRATE_SETTINGS_SUCCESS:
      return {
        ...state,
        globalSettings: { ...state.globalSettings, complete: true },
      };
    case actions.SETTINGS_FETCH_FAIL:
      return {
        ...state,
        globalSettings: {
          ...state.globalSettings,
          failed: true,
          complete: true,
        },
      };
    default:
      return state;
  }
}

export default settingsReducer;
